(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cap-cart-controller"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cap-cart-controller')) {
    customElements.define('cap-cart-controller', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.drawer = document.querySelector('cart-drawer');
        this.needsRefresh = false;
        window.CapCart = { add: this.add.bind(this), refresh: this.refresh.bind(this) };
        document.addEventListener('click', event => {
          const trigger = event.target.closest('.header__icon--cart');
          if (!trigger || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || !this.drawer) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          this.open(trigger);
        }, { capture: true, signal: this.controller.signal });
        document.addEventListener('keydown', event => {
          if (event.key !== ' ' || !event.target.matches('.header__icon--cart')) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          this.open(event.target);
        }, { capture: true, signal: this.controller.signal });
        this.observer = new MutationObserver(() => this.updateExpandedState());
        if (this.drawer) this.observer.observe(this.drawer, { attributes: true, attributeFilter: ['class'] });
        this.updateExpandedState();
      }
      disconnectedCallback() { this.controller?.abort(); this.controller = null; this.observer?.disconnect(); }
      updateExpandedState() {
        const open = this.drawer?.classList.contains('active') || false;
        document.querySelectorAll('.header__icon--cart').forEach(icon => {
          icon.setAttribute('aria-haspopup', 'dialog');
          icon.setAttribute('aria-controls', 'CartDrawer');
          icon.setAttribute('aria-expanded', String(open));
        });
      }
      refresh(data) {
        const html = data.sections?.['cart-drawer'];
        if (!html || !this.drawer) { this.needsRefresh = true; return false; }
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const source = parsed.querySelector('cart-drawer');
        const sourceInner = source?.querySelector('.drawer__inner');
        const targetInner = this.drawer.querySelector('.drawer__inner');
        if (!sourceInner || !targetInner) { this.needsRefresh = true; return false; }
        const wasOpen = this.drawer.classList.contains('active');
        targetInner.innerHTML = sourceInner.innerHTML;
        this.drawer.classList.toggle('is-empty', source.classList.contains('is-empty'));
        const bubble = document.getElementById('cart-icon-bubble');
        const bubbleHtml = data.sections?.['cart-icon-bubble'];
        if (bubble && bubbleHtml) {
          const bubbleDocument = new DOMParser().parseFromString(bubbleHtml, 'text/html');
          const bubbleContent = bubbleDocument.getElementById('cart-icon-bubble') || bubbleDocument.getElementById('shopify-section-cart-icon-bubble') || bubbleDocument.body;
          bubble.innerHTML = bubbleContent.innerHTML;
        }
        this.needsRefresh = !bubbleHtml;
        if (wasOpen && typeof this.drawer.open === 'function') this.drawer.open();
        this.updateExpandedState();
        return true;
      }
      async add(id, quantity, opener) {
        const response = await fetch(this.dataset.addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            items: [{ id: String(id), quantity: Number(quantity) }],
            sections: ['cart-drawer', 'cart-icon-bubble'],
            sections_url: window.location.pathname
          })
        });
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || window.cartStrings?.error || response.statusText);
        this.refresh(data);
        if (this.drawer && !this.drawer.classList.contains('active')) {
          await this.open(opener || document.querySelector('.header__icon--cart'));
        }
        return data;
      }
      async open(trigger) {
        if (this.opening) return;
        this.opening = true;
        try {
          if (this.needsRefresh) {
            trigger.setAttribute('aria-busy', 'true');
            const url = new URL(window.location.href);
            url.searchParams.set('sections', 'cart-drawer,cart-icon-bubble');
            try {
              const response = await fetch(url.href, { headers: { 'Accept': 'application/json' } });
              if (response.ok) this.refresh({ sections: await response.json() });
            } catch {}
          }
          this.drawer.setActiveElement?.(trigger);
          if (typeof this.drawer.open === 'function') this.drawer.open(trigger);
          this.updateExpandedState();
        } finally {
          trigger.removeAttribute('aria-busy');
          this.opening = false;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cap-cart-upsell"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cap-cart-upsell')) {
    customElements.define('cap-cart-upsell', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.config = JSON.parse(this.querySelector('[data-cap-variants]').textContent);
        this.radios = Array.from(this.querySelectorAll('input[type="radio"]'));
        this.addButton = this.querySelector('[data-cap-add]');
        this.message = this.querySelector('.cap-cart-upsell__message');
        this.addEventListener('change', event => {
          if (event.target.matches('input[type="radio"]')) this.select(event.target.value);
        }, options);
        this.querySelector('[data-cap-previous]').addEventListener('click', () => this.move(-1), options);
        this.querySelector('[data-cap-next]').addEventListener('click', () => this.move(1), options);
        this.addButton.addEventListener('click', () => this.add(), options);
        this.select(this.radios.find(radio => radio.checked)?.value);
      }
      disconnectedCallback() { this.controller?.abort(); this.controller = null; }
      select(id) {
        this.variant = this.config.variants.find(variant => variant.id === id) || this.config.variants[0];
        if (!this.variant) return;
        this.radios.forEach(radio => { radio.checked = radio.value === this.variant.id; });
        this.querySelector('[data-cap-price]').textContent = this.variant.price;
        const compare = this.querySelector('[data-cap-compare]');
        compare.textContent = this.variant.compare;
        compare.hidden = !this.variant.onSale;
        const image = this.querySelector('.cap-cart-upsell__image');
        if (image && this.variant.image) { image.removeAttribute('srcset'); image.src = this.variant.image; image.alt = this.variant.title; }
        this.message.textContent = '';
        const noStock = !this.variant.available || (this.variant.tracked && this.variant.policy === 'deny' && this.variant.inCart >= this.variant.inventory);
        this.addButton.disabled = noStock || this.busy;
        this.addButton.textContent = noStock ? this.config.labels.unavailable : this.config.labels.add;
        this.addButton.setAttribute('aria-label', this.config.labels.addColor.replace('__COLOR__', this.variant.title));
      }
      move(direction) {
        if (this.busy) return;
        const index = this.config.variants.indexOf(this.variant);
        const next = (index + direction + this.config.variants.length) % this.config.variants.length;
        this.select(this.config.variants[next].id);
      }
      async add() {
        if (this.busy || this.addButton.disabled) return;
        this.busy = true;
        this.setAttribute('aria-busy', 'true');
        this.addButton.disabled = true;
        this.addButton.textContent = this.config.labels.adding;
        this.radios.forEach(radio => { radio.disabled = true; });
        this.message.textContent = '';
        try {
          if (!window.CapCart?.add) throw new Error(this.config.labels.error);
          await window.CapCart.add(this.variant.id, 1);
        } catch (error) {
          this.message.textContent = error.message || this.config.labels.error;
        } finally {
          this.busy = false;
          this.removeAttribute('aria-busy');
          this.radios.forEach(radio => { radio.disabled = false; });
          if (this.isConnected) { this.addButton.disabled = false; this.addButton.textContent = this.config.labels.add; }
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cap-product-information"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cap-product-information')) {
    customElements.define('cap-product-information', class extends HTMLElement {
      connectedCallback() {
        if (this._controller) return;
        this._controller = new AbortController();
        const options = { signal: this._controller.signal };
        this.tabs = [...this.querySelectorAll('.cap-info__tab')];
        this.items = [...this.querySelectorAll('.cap-info__item')];
        this.panels = [...this.querySelectorAll('.cap-info__panel')];
        this.tablist = this.querySelector('[role="tablist"]');
        this.activeIndex ??= 0;
        this.mobileOpen ??= new Set(this.items.map((item, index) => item.open ? index : -1).filter(index => index >= 0));
        this.desktop = this.hasAttribute('data-desktop');
        this.media = window.matchMedia('(min-width: 750px)');
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.selectTab(index), options);
          tab.addEventListener('keydown', event => {
            let next;
            const direction = getComputedStyle(this).direction === 'rtl' ? -1 : 1;
            if (event.key === 'ArrowRight') next = (index + direction + this.tabs.length) % this.tabs.length;
            if (event.key === 'ArrowLeft') next = (index - direction + this.tabs.length) % this.tabs.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = this.tabs.length - 1;
            if (next === undefined) return;
            event.preventDefault();
            this.selectTab(next);
            this.tabs[next].focus();
          }, options);
        });
        this.media.addEventListener('change', () => this.updateLayout(), options);
        this.updateLayout();
      }
      disconnectedCallback() {
        this._controller?.abort();
        this._controller = null;
      }
      selectTab(index) {
        this.activeIndex = index;
        this.tabs.forEach((tab, position) => {
          tab.setAttribute('aria-selected', String(position === index));
          tab.tabIndex = position === index ? 0 : -1;
          this.items[position].hidden = this.desktop && position !== index;
        });
      }
      updateLayout() {
        const nextDesktop = this.media.matches;
        const activeElement = document.activeElement;
        const focusedTab = this.tabs.indexOf(activeElement);
        const focusedSummary = this.items.findIndex(item => item.querySelector('summary') === activeElement);
        if (!this.desktop) {
          this.mobileOpen = new Set(this.items.map((item, index) => item.open ? index : -1).filter(index => index >= 0));
        }
        this.desktop = nextDesktop;
        this.toggleAttribute('data-desktop', nextDesktop);
        this.tablist.hidden = !nextDesktop;
        this.items.forEach((item, index) => {
          item.open = nextDesktop || this.mobileOpen.has(index);
          this.panels[index].setAttribute('role', nextDesktop ? 'tabpanel' : 'region');
          this.panels[index].setAttribute('aria-labelledby', nextDesktop ? this.tabs[index].id : item.querySelector('summary').id);
          if (nextDesktop) this.panels[index].tabIndex = 0;
          else this.panels[index].removeAttribute('tabindex');
        });
        this.selectTab(nextDesktop && focusedSummary >= 0 ? focusedSummary : this.activeIndex);
        if (nextDesktop && focusedSummary >= 0) this.tabs[this.activeIndex].focus();
        if (!nextDesktop && focusedTab >= 0) this.items[this.activeIndex].querySelector('summary').focus();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cap-review-carousel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cap-review-carousel')) {
    customElements.define('cap-review-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.track = this.querySelector('[data-review-track]');
        this.cards = [...this.querySelectorAll('[data-review-card]')];
        this.dots = [...this.querySelectorAll('[data-review-dot]')];
        this.navigation = this.querySelector('[data-review-dots]');
        if (!this.track || !this.cards.length) return;
        this.activeIndex = 0;
        this.setupReadMore(options);
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.goTo(index), options));
        this.track.addEventListener('scroll', () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
        }, { ...options, passive: true });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track) return;
          let next = this.activeIndex;
          const direction = getComputedStyle(this).direction === 'rtl' ? -1 : 1;
          if (event.key === 'ArrowRight') next += direction;
          else if (event.key === 'ArrowLeft') next -= direction;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = this.cards.length - 1;
          else return;
          event.preventDefault();
          this.goTo(next);
        }, options);
        this.addEventListener('shopify:block:select', event => {
          const card = event.target.closest('[data-review-card]');
          const index = this.cards.indexOf(card);
          if (index >= 0) this.goTo(index);
        }, options);
        this.observer = new ResizeObserver(() => this.update());
        this.observer.observe(this.track);
        this.update();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
        if (this.dialog?.open) this.dialog.close();
        this.removeAttribute('data-review-ready');
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = null;
      }
      setupReadMore(options) {
        this.dialog = this.querySelector('[data-review-dialog]');
        if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
        this.dialogTitle = this.dialog.querySelector('[data-review-dialog-title]');
        this.dialogBody = this.dialog.querySelector('[data-review-dialog-body]');
        this.dialogMeta = this.dialog.querySelector('[data-review-dialog-meta]');
        this.cards.forEach(card => {
          const button = card.querySelector('[data-review-more]');
          button?.addEventListener('click', () => this.openReview(card, button), options);
        });
        this.dialog.querySelector('[data-review-close]').addEventListener('click', () => this.dialog.close(), options);
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        }, options);
        this.dialog.addEventListener('close', () => {
          if (this.reviewTrigger?.isConnected) this.reviewTrigger.focus({ preventScroll: true });
        }, options);
        this.setAttribute('data-review-ready', '');
        document.fonts?.ready.then(() => {
          if (this.controller && this.isConnected) this.updateReadMore();
        });
      }
      updateReadMore() {
        if (!this.hasAttribute('data-review-ready')) return;
        this.cards.forEach(card => {
          const body = card.querySelector('.cap-review-card__body');
          const title = card.querySelector('.cap-review-card__title');
          const button = card.querySelector('[data-review-more]');
          const clipped = [body, title].some(element => element && element.scrollHeight > element.clientHeight + 1);
          if (button) button.hidden = !clipped;
        });
      }
      openReview(card, trigger) {
        const title = card.querySelector('.cap-review-card__title');
        const body = card.querySelector('.cap-review-card__body');
        const meta = card.querySelector('.cap-review-card__meta');
        this.dialogTitle.textContent = title?.textContent || '';
        this.dialogBody.innerHTML = body?.innerHTML || '';
        this.dialogMeta.innerHTML = meta?.innerHTML || '';
        this.reviewTrigger = trigger;
        this.dialog.showModal();
      }
      goTo(index) {
        const target = Math.max(0, Math.min(this.cards.length - 1, index));
        const rtl = getComputedStyle(this).direction === 'rtl';
        const trackRect = this.track.getBoundingClientRect();
        const cardRect = this.cards[target].getBoundingClientRect();
        const offset = rtl ? cardRect.right - trackRect.right : cardRect.left - trackRect.left;
        this.track.scrollTo({ left: this.track.scrollLeft + offset, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }
      update() {
        this.updateReadMore();
        this.navigation.hidden = this.track.scrollWidth <= this.track.clientWidth + 1;
        const rtl = getComputedStyle(this).direction === 'rtl';
        const trackRect = this.track.getBoundingClientRect();
        let nearest = 0;
        let distance = Infinity;
        this.cards.forEach((card, index) => {
          const rect = card.getBoundingClientRect();
          const current = Math.abs(rtl ? rect.right - trackRect.right : rect.left - trackRect.left);
          if (current < distance) { distance = current; nearest = index; }
        });
        if (!this.navigation.hidden && Math.abs(this.track.scrollLeft) >= this.track.scrollWidth - this.track.clientWidth - 1) nearest = this.cards.length - 1;
        this.activeIndex = nearest;
        this.dots.forEach((dot, index) => {
          if (index === nearest) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
